import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { server, files } from "../configs";
import { Context } from "../GlobalContext";
import InfoSelectSeven from "../components/InfoSelectSeven";
import Axios from "axios";
import Swal from "sweetalert2";
import "../global/pages.css";
import "./Info.css";

const InfoTwo = ({ history }) => {
  const [localSatisfaction, setLocalSatisfaction] = useState(0);
  const [lifeSatisfaction, setLifeSatisfaction] = useState(0);
  const [happiness, setHappiness] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    token,
    userData,
    selfData,
    setSelfData,
    reqInfoPages,
    firstSurvType,
  } = useContext(Context);

  const fieldsList = userData.requiredInfo;

  const submit = () => {
    if (
      (localSatisfaction !== 0 ||
        fieldsList.findIndex((field) => field.includes("localSatisfaction")) ===
          -1) &&
      (lifeSatisfaction !== 0 ||
        fieldsList.findIndex((field) => field.includes("lifeSatisfaction")) ===
          -1) &&
      (happiness !== 0 ||
        fieldsList.findIndex((field) => field.includes("happiness")) === -1)
    ) {
      const jwt = localStorage.getItem("jwt");
      Axios.patch(
        server + "/user/users/me",
        {
          localSatisfaction:
            fieldsList.findIndex((field) =>
              field.includes("localSatisfaction")
            ) >= 0
              ? localSatisfaction
              : null,
          lifeSatisfaction:
            fieldsList.findIndex((field) =>
              field.includes("lifeSatisfaction")
            ) >= 0
              ? lifeSatisfaction
              : null,
          happiness:
            fieldsList.findIndex((field) => field.includes("happiness")) >= 0
              ? happiness
              : null,
        },
        {
          headers: { authorization: jwt },
        }
      )
        .then(({ status }) => {
          // Remove data that's on the server from localStorage to separate
          // how data is managed
          localStorage.removeItem("info-2");

          setSelfData({
            ...selfData,
            localSatisfaction,
            lifeSatisfaction,
            happiness,
          });

          const nextPage = `/token/${token}/intro/${firstSurvType}/0/0/0`; // Depending on which survey comes first, set surveyType of a/b/c
          history.push(nextPage);

          // console.log(status);
        })
        .catch((e) => {
          console.log(e);
          history.push("/noToken");
        });
    } else {
      const listMsg =
        (localSatisfaction !== 0 ||
        fieldsList.findIndex((field) => field.includes("localSatisfaction")) ===
          -1
          ? ""
          : "지역사회에 대한 만족도, ") +
        (lifeSatisfaction !== 0 ||
        fieldsList.findIndex((field) => field.includes("lifeSatisfaction")) ===
          -1
          ? ""
          : "삶의 만족도, ") +
        (happiness !== 0 ||
        fieldsList.findIndex((field) => field.includes("happiness")) === -1
          ? ""
          : "행복감의 수준, ");
      Swal.fire({
        title: "확인해 주세요!",
        confirmButtonText: "닫기",
        confirmButtonColor: "#00aeef",
        text: listMsg.substring(0, listMsg.length - 2) + "을(를) 표시해주세요.",
        heightAuto: false,
      });
    }
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("info-2"));

    if (saved) {
      setLocalSatisfaction(saved.localSatisfaction);
      setLifeSatisfaction(saved.lifeSatisfaction);
      setHappiness(saved.happiness);
    } else {
      setLocalSatisfaction(
        selfData.localSatisfaction ? selfData.localSatisfaction : 0
      );
      setLifeSatisfaction(
        selfData.lifeSatisfaction ? selfData.lifeSatisfaction : 0
      );
      setHappiness(selfData.happiness ? selfData.happiness : 0);
    }

    setIsLoaded(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "info-2",
      JSON.stringify({
        localSatisfaction,
        lifeSatisfaction,
        happiness,
      })
    );
  }, [localSatisfaction, lifeSatisfaction, happiness]);

  return (
    isLoaded && (
      <div className="container iinnffoo" id="info__container">
        <div className="title" id="info__title">
          <div className="icon">
            <img src={files + "/talk.svg"} alt="참여를 위한 기본 정보" />
          </div>
          <h3>들어가는 질문</h3>
        </div>
        <div className="content" id="info__content">
          <div className="info-box">
            {fieldsList.findIndex((field) =>
              field.includes("localSatisfaction")
            ) >= 0 && (
              <div className="question-two">
                <b>나는 지금 살고 있는 지역에 만족합니다</b>
                <div className="red-dot" />
                <InfoSelectSeven
                  id="local-sat-select"
                  setDegree={setLocalSatisfaction}
                  degree={localSatisfaction}
                  leftLabel="매우 불만족"
                  rightLabel="매우 만족"
                />
              </div>
            )}
            {fieldsList.findIndex((field) =>
              field.includes("lifeSatisfaction")
            ) >= 0 && (
              <div className="question-two">
                <b>나는 현재 삶에 만족합니다.</b>
                <div className="red-dot" />
                <InfoSelectSeven
                  id="life-sat-select"
                  setDegree={setLifeSatisfaction}
                  degree={lifeSatisfaction}
                  leftLabel="매우 불만족"
                  rightLabel="매우 만족"
                />
              </div>
            )}
            {fieldsList.findIndex((field) => field.includes("happiness")) >=
              0 && (
              <div className="question-two">
                <b>나는 행복합니다.</b>
                <div className="red-dot" />
                <InfoSelectSeven
                  id="happiness-select"
                  setDegree={setHappiness}
                  degree={happiness}
                  leftLabel="&nbsp;매우 불행"
                  rightLabel="매우 행복"
                />
              </div>
            )}
          </div>
        </div>

        <div className="link-buttons">
          <Link
            to={
              reqInfoPages.needsInfoOne
                ? `/token/${token}/info-1`
                : `/token/${token}/greeting`
            }
            className="link-btn"
            alt="뒤로 버튼"
          >
            뒤로
          </Link>
          <button className="link-btn" onClick={submit} alt="다음으로 버튼">
            다음으로
          </button>
        </div>
      </div>
    )
  );
};

export default InfoTwo;
